import { decode, } from "../encoding";
import type { MessageHandler, } from "../types";
import { getConnection } from "./getConnection";
import { connections, connectionListenersInitialized, } from "./shared";
import { subscriptions, } from "./subscriptions";


export declare type SubscriptionPath = `${string}.${string}`;

export declare type SubscribeProps = {
	path: string;
	onMessage: MessageHandler;
}

export declare type SubscriptionCollection = {
	[k in SubscriptionPath]: MessageHandler[];
}

export const subscribe = async ( paths: SubscriptionPath|SubscriptionPath[], onMessage: MessageHandler, ): Promise<() => void> => {

	paths = Array.isArray(paths) ? paths : [paths];

	if(!connections.has("default")) {
		connections.set("default", await getConnection() );
	}

	const client = connections.get("default");

	if(client) {

		// Initialize event listeners only once per connection
		if(!connectionListenersInitialized.has("default")) {
			client.on("message", async ( _, body, pkt, ) => {
				const message = decode(body.toString());
				const topic = pkt.topic.replace(/\//g, ".") as SubscriptionPath;
				const handlers = subscriptions.get(topic);
				if(Array.isArray(handlers)) {
					await Promise.all(handlers.map(handler => handler(message, topic, pkt)));
				}
			});

			client.on("error", err => {
				console.log("MQTT connection error", err.message);
			});

			connectionListenersInitialized.add("default");
		}

		for(const rawpath of paths) {

			const path = rawpath.toLowerCase() as SubscriptionPath;
			const sub = subscriptions.get(path);

			if(sub) {
				if(!sub.includes(onMessage)) {
					sub.push(onMessage);
				}
			}
			else {
				subscriptions.set(path, [onMessage]);
				client.subscribe(path);
			}

		}

		return () => {
			for(const rawpath of paths) {
				const path = rawpath.toLowerCase() as SubscriptionPath;
				const subs = subscriptions.get(path);
				if(subs && subs.length > 1) {
					const idx = subs.indexOf(onMessage);
					subs.splice(idx, 1);
				}
				else {
					subscriptions.delete(path);
					client.unsubscribe(path);
				}
			}
		};

	}

	throw new Error("MQTT connection not found");

};
